(function ($) {
    $(document).ready(function () {
        initPageLoader();
        initHeroFade();
        initHomeBrandVideo();
        initScrollReveal();
        initSiteNav();
        initContactMap();
        initInsightsTestimonialsSlider();
        initInsightsCategoryFilter();
    });

    function initPageLoader() {
        var loader = document.getElementById('page-loader');
        var body = document.body;
        var minDisplayMs = 350;
        var startTime = Date.now();
        var isHidden = false;

        if (!loader) {
            body.classList.remove('is-loading');
            document.dispatchEvent(new CustomEvent('fienix:pageloaded'));
            return;
        }

        function hideLoader() {
            if (isHidden) {
                return;
            }

            isHidden = true;
            var elapsed = Date.now() - startTime;
            var remaining = Math.max(0, minDisplayMs - elapsed);

            setTimeout(function () {
                loader.classList.add('is-hidden');
                body.classList.remove('is-loading');
                loader.setAttribute('aria-hidden', 'true');
                document.dispatchEvent(new CustomEvent('fienix:pageloaded'));
            }, remaining);
        }

        if (document.readyState === 'complete') {
            hideLoader();
        } else {
            window.addEventListener('load', hideLoader);
        }

        setTimeout(hideLoader, 5000);
    }

    function initHeroFade() {
        var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var staggerMs = 500;
        var sequences = [];

        function revealElement(element) {
            if (!element) {
                return;
            }

            requestAnimationFrame(function () {
                element.classList.add('is-visible');
            });
        }

        document.querySelectorAll('#main-content .diensten-hero').forEach(function (hero) {
            var media = hero.querySelector('.diensten-hero__media');
            var content = hero.querySelector('.diensten-hero__content');

            sequences.push(
                { element: media, delay: 0 },
                { element: content, delay: staggerMs }
            );
        });

        var homeHero = document.querySelector('#main-content .home-page > .home-hero');
        var homeBrand = document.querySelector('#main-content .home-page > .home-brand');
        var homeTagline = document.querySelector('#main-content .home-page > .home-tagline');
        var homeFadeDelay = 0;

        if (homeHero) {
            sequences.push({ element: homeHero, delay: homeFadeDelay });
            homeFadeDelay += staggerMs;
        }

        if (homeBrand) {
            sequences.push({ element: homeBrand, delay: homeFadeDelay });
            homeFadeDelay += staggerMs;
        }

        if (homeTagline) {
            sequences.push({ element: homeTagline, delay: homeFadeDelay });
        }

        var contactTitle = document.querySelector('#main-content .contact-section__title');
        var contactIntro = document.querySelector('#main-content .contact-section__intro');

        if (contactTitle) {
            sequences.push({ element: contactTitle, delay: 0 });
        }

        if (contactIntro) {
            sequences.push({ element: contactIntro, delay: contactTitle ? 220 : 0 });
        }

        if (!sequences.length) {
            return;
        }

        function runSequences() {
            sequences.forEach(function (step) {
                if (prefersReducedMotion) {
                    revealElement(step.element);
                    return;
                }

                setTimeout(function () {
                    revealElement(step.element);
                }, step.delay);
            });
        }

        document.addEventListener('fienix:pageloaded', runSequences, { once: true });
    }

    function initScrollReveal() {
        var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        initHomeIntroReveal(prefersReducedMotion);

        var targets = document.querySelectorAll(
            '#main-content section:not(.home-hero):not(.diensten-hero):not(.home-brand):not(.home-tagline):not(.home-intro), #main-content .entry-content > *'
        );

        if (!targets.length) {
            return;
        }

        if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
            targets.forEach(function (element) {
                element.classList.add('is-visible');
            });
            return;
        }

        targets.forEach(function (element) {
            element.classList.add('reveal');
        });

        var observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) {
                        return;
                    }

                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                });
            },
            {
                threshold: 0.08,
                rootMargin: '0px 0px -2% 0px'
            }
        );

        targets.forEach(function (element) {
            observer.observe(element);
        });
    }

    function initHomeIntroReveal(prefersReducedMotion) {
        var sections = document.querySelectorAll('#main-content .home-intro');

        if (!sections.length) {
            return;
        }

        sections.forEach(function (section) {
            var media = section.querySelector('.home-intro__media');
            var content = section.querySelector('.home-intro__content');

            if (media) {
                media.classList.add('reveal-prominent');
            }

            if (content) {
                content.classList.add('reveal-prominent');
            }

            if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
                if (media) {
                    media.classList.add('is-visible');
                }

                if (content) {
                    content.classList.add('is-visible');
                }

                return;
            }

            var observer = new IntersectionObserver(
                function (entries) {
                    entries.forEach(function (entry) {
                        if (!entry.isIntersecting) {
                            return;
                        }

                        var introMedia = entry.target.querySelector('.home-intro__media');
                        var introContent = entry.target.querySelector('.home-intro__content');

                        requestAnimationFrame(function () {
                            if (introMedia) {
                                introMedia.classList.add('is-visible');
                            }

                            if (introContent) {
                                introContent.classList.add('is-visible');
                            }
                        });

                        observer.unobserve(entry.target);
                    });
                },
                {
                    threshold: 0.18,
                    rootMargin: '0px 0px -10% 0px'
                }
            );

            observer.observe(section);
        });
    }

    function initStaggeredSectionReveal(prefersReducedMotion, sectionSelector, itemSelector) {
        var sections = document.querySelectorAll(sectionSelector);

        if (!sections.length) {
            return;
        }

        sections.forEach(function (section) {
            var items = section.querySelectorAll(itemSelector);

            if (!items.length) {
                return;
            }

            items.forEach(function (item, index) {
                item.classList.add('reveal-soft');

                if (index === 1) {
                    item.classList.add('reveal-soft--delay-1');
                } else if (index >= 2) {
                    item.classList.add('reveal-soft--delay-2');
                }
            });

            if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
                items.forEach(function (item) {
                    item.classList.add('is-visible');
                });
                return;
            }

            var observer = new IntersectionObserver(
                function (entries) {
                    entries.forEach(function (entry) {
                        if (!entry.isIntersecting) {
                            return;
                        }

                        entry.target.querySelectorAll(itemSelector).forEach(function (item) {
                            requestAnimationFrame(function () {
                                item.classList.add('is-visible');
                            });
                        });

                        observer.unobserve(entry.target);
                    });
                },
                {
                    threshold: 0.15,
                    rootMargin: '0px 0px -8% 0px'
                }
            );

            observer.observe(section);
        });
    }

    function initSiteNav() {
        var nav = document.getElementById('site-nav');

        if (!nav) {
            return;
        }

        var toggle = nav.querySelector('.site-nav__toggle');
        var panel = nav.querySelector('.site-nav__panel');
        var overlay = nav.querySelector('[data-nav-overlay]');
        var mq = window.matchMedia('(max-width: 991px)');

        function setMenuState(isOpen) {
            nav.classList.toggle('is-open', isOpen);
            toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            toggle.setAttribute('aria-label', isOpen ? 'Menu sluiten' : 'Menu openen');
            document.body.style.overflow = isOpen && mq.matches ? 'hidden' : '';

            if (overlay) {
                overlay.hidden = !isOpen;
            }
        }

        function closeMenu() {
            setMenuState(false);
        }

        toggle.addEventListener('click', function () {
            setMenuState(!nav.classList.contains('is-open'));
        });

        if (overlay) {
            overlay.addEventListener('click', closeMenu);
        }

        panel.querySelectorAll('a').forEach(function (link) {
            link.addEventListener('click', function () {
                if (mq.matches) {
                    closeMenu();
                }
            });
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                closeMenu();
            }
        });

        mq.addEventListener('change', function () {
            if (!mq.matches) {
                closeMenu();
            }
        });
    }

    function initHomeBrandVideo() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        document.querySelectorAll('.home-brand__background--video').forEach(function (video) {
            var media = video.closest('.home-brand__media--video');
            var hasStarted = false;
            var fallbackApplied = false;

            function applyPosterFallback() {
                if (fallbackApplied || !media) {
                    return;
                }

                fallbackApplied = true;
                media.classList.add('is-video-fallback');
            }

            function prepareVideo() {
                video.defaultMuted = true;
                video.muted = true;
                video.volume = 0;
                video.controls = false;
                video.removeAttribute('controls');
                video.setAttribute('playsinline', '');
                video.setAttribute('webkit-playsinline', '');
                video.playbackRate = 0.5;
            }

            function tryPlay() {
                if (fallbackApplied) {
                    return;
                }

                prepareVideo();

                var playPromise = video.play();

                if (!playPromise || typeof playPromise.then !== 'function') {
                    return;
                }

                playPromise
                    .then(function () {
                        hasStarted = true;

                        if (media) {
                            media.classList.remove('is-video-fallback');
                        }
                    })
                    .catch(function () {
                        if (!hasStarted && video.readyState >= 2) {
                            applyPosterFallback();
                        }
                    });
            }

            prepareVideo();

            ['loadeddata', 'canplay', 'canplaythrough'].forEach(function (eventName) {
                video.addEventListener(eventName, tryPlay, { once: false });
            });

            document.addEventListener('fienix:pageloaded', tryPlay, { once: true });
            window.addEventListener('pageshow', tryPlay);
            document.addEventListener('visibilitychange', function () {
                if (!document.hidden) {
                    tryPlay();
                }
            });

            if (typeof IntersectionObserver !== 'undefined' && media) {
                var observer = new IntersectionObserver(
                    function (entries) {
                        entries.forEach(function (entry) {
                            if (entry.isIntersecting) {
                                tryPlay();
                            }
                        });
                    },
                    { threshold: 0.01 }
                );

                observer.observe(media);
            }

            video.addEventListener('canplaythrough', function () {
                setTimeout(function () {
                    if (!hasStarted && video.paused) {
                        applyPosterFallback();
                    }
                }, 500);
            }, { once: true });

            tryPlay();
        });
    }

    function initContactMap() {
        var mapElement = document.getElementById('contact-map');

        if (!mapElement || typeof L === 'undefined') {
            return;
        }

        var lat = parseFloat(mapElement.dataset.lat);
        var lng = parseFloat(mapElement.dataset.lng);
        var zoom = parseInt(mapElement.dataset.zoom, 10) || 14;
        var address = mapElement.dataset.address || '';

        if (isNaN(lat) || isNaN(lng)) {
            return;
        }

        var map = L.map(mapElement, {
            scrollWheelZoom: false,
            zoomControl: true,
            worldCopyJump: false
        }).setView([lat, lng], zoom);

        var bounds = L.latLngBounds(
            [lat - 0.04, lng - 0.06],
            [lat + 0.04, lng + 0.06]
        );

        map.setMaxBounds(bounds);
        map.options.maxBoundsViscosity = 1.0;

        L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: 'abcd',
            maxZoom: 19,
            noWrap: true
        }).addTo(map);

        var markerIcon = L.icon({
            iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
            shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
        });

        var marker = L.marker([lat, lng], { icon: markerIcon }).addTo(map);

        if (address) {
            marker.bindPopup(address);
        }

        setTimeout(function () {
            map.invalidateSize();
        }, 200);
    }

    function equalizeInsightsTestimonialHeights($slider) {
        var isMobile = window.matchMedia('(max-width: 767px)').matches;

        $slider.find('.slick-slide').css('height', '');

        if (isMobile) {
            return;
        }

        var maxHeight = 0;

        $slider.find('.slick-slide').each(function () {
            var slideHeight = $(this).outerHeight();

            if (slideHeight > maxHeight) {
                maxHeight = slideHeight;
            }
        });

        if (maxHeight > 0) {
            $slider.find('.slick-slide').css('height', maxHeight);
        }
    }

    function initInsightsTestimonialsSlider() {
        if (typeof $.fn.slick !== 'function') {
            return;
        }

        $('.insights-testimonials__slider').each(function () {
            var $slider = $(this);

            if ($slider.hasClass('slick-initialized')) {
                return;
            }

            var $carousel = $slider.closest('.insights-testimonials__carousel');
            var count = parseInt($carousel.data('count'), 10) || $slider.children().length;
            var desktopSlides = Math.min(3, count);
            var useDesktopSlider = count > 3;

            $slider.on('init setPosition reInit', function () {
                equalizeInsightsTestimonialHeights($slider);
            });

            $slider.slick({
                slidesToShow: desktopSlides,
                slidesToScroll: 1,
                infinite: useDesktopSlider,
                arrows: useDesktopSlider,
                dots: false,
                adaptiveHeight: false,
                prevArrow: $carousel.find('.insights-testimonials__arrow--prev'),
                nextArrow: $carousel.find('.insights-testimonials__arrow--next'),
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: count > 1,
                            arrows: count > 1,
                            adaptiveHeight: true
                        }
                    }
                ]
            });

            $(window).on('resize.insightsTestimonials', function () {
                equalizeInsightsTestimonialHeights($slider);
            });
        });
    }

    function initInsightsCategoryFilter() {
        var $filter = $('[data-insights-filter]');

        if (!$filter.length || typeof object_name === 'undefined' || !object_name.ajax_url) {
            return;
        }

        var $results = $('[data-insights-results]');

        if (!$results.length) {
            return;
        }

        var $cards = $results.find('.insights-grid__cards');
        var $pagination = $results.find('[data-insights-pagination]');
        var isLoading = false;

        $filter.on('click', '.insights-filters__button', function () {
            var $button = $(this);

            if ($button.hasClass('is-active') || isLoading) {
                return;
            }

            var category = $button.data('category') || '';

            $filter.find('.insights-filters__button').removeClass('is-active').attr('aria-selected', 'false');
            $button.addClass('is-active').attr('aria-selected', 'true');

            isLoading = true;
            $results.addClass('is-loading');

            $.ajax({
                url: object_name.ajax_url,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'fienix_filter_insights',
                    nonce: object_name.insights_nonce,
                    category: category
                }
            }).done(function (response) {
                if (!response || !response.success || !response.data) {
                    return;
                }

                $cards.stop(true, true).fadeTo(160, 0, function () {
                    $cards.html(response.data.html);

                    if (response.data.pagination) {
                        if ($pagination.length) {
                            $pagination.html(response.data.pagination).show();
                        } else {
                            $results.append(
                                '<nav class="archive-pagination archive-pagination--insights insights-grid__pagination" aria-label="Paginatie" data-insights-pagination>' +
                                response.data.pagination +
                                '</nav>'
                            );
                            $pagination = $results.find('[data-insights-pagination]');
                        }
                    } else if ($pagination.length) {
                        $pagination.empty().hide();
                    }

                    $results.removeClass('is-loading');
                    $cards.fadeTo(220, 1);
                    isLoading = false;
                });
            }).fail(function () {
                $results.removeClass('is-loading');
                isLoading = false;
            });
        });
    }
})(jQuery);
